import type { BasicStoreFragment } from '@drycut/graphql';

import { Heading, Para, Stack } from '@drycut/ui-components';
import { Link } from 'react-router';

import { StoreWaitingTime } from '../StoreWaitingTime';

type Props = {
  includeWaitingTime?: boolean;
  salon: BasicStoreFragment;
};

export default function SalonCard({ salon, includeWaitingTime }: Props): React.ReactElement {
  const to = `/${salon.slug}`;

  return (
    <Stack
      as={Link}
      to={to}
      className="group transition-all bg-white shadow hover:shadow-md hover:bg-zinc-100"
    >
      <Stack gap={2} className="p-4">
        <Stack>
          <Heading variant="h1" className="text-4xl text-left leading-none">
            {salon.name}
          </Heading>

          <Heading variant="h5" className="text-zinc-500 text-left text-sm">
            {salon?.location?.street}, {salon?.location?.zipCode} {salon?.location?.city}
          </Heading>
        </Stack>

        {includeWaitingTime && (
          <Stack direction="row" gap={1} className="justify-start">
            <Para as="span" size="sm" className="text-zinc-600">
              <StoreWaitingTime store={salon} showZero long hours />
            </Para>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
